import { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, FormControl, Typography, TextField, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { SCA } from './authenticationTab.classes';

export const AuthenticationTab = () => {
    const [showPassword, setShowPassword] = useState(false);

    const { control } = useFormContext();
    const { t } = useTranslation();

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Box className={SCA.root} sx={{ width: '600px' }}>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.address')}
                </Typography>
                <Controller
                    name="address"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.addressInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterAddress')}
                        />
                    )}
                />
            </FormControl>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.contentType')}
                </Typography>
                <Controller
                    name="contentType"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.contentTypeInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterContentType')}
                        />
                    )}
                />
            </FormControl>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.clientId')}
                </Typography>
                <Controller
                    name="clientId"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.clientIdInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterClientId')}
                        />
                    )}
                />
            </FormControl>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.clientSecret')}
                </Typography>
                <Controller
                    name="clientSecret"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.clientKeyInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterClientSecret')}
                        />
                    )}
                />
            </FormControl>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.username')}
                </Typography>
                <Controller
                    name="username"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.usernameInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterUsername')}
                        />
                    )}
                />
            </FormControl>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.password')}
                </Typography>
                <Controller
                    name="password"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.authCredentialInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterPassword')}
                            type={showPassword ? 'text' : 'password'}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                className={SCA.credentialVisibilityButton}
                                                onClick={handleClickShowPassword}
                                                edge="end"
                                            >
                                                {showPassword ? (
                                                    <VisibilityOff className={SCA.credentialVisibilityIcon} />
                                                ) : (
                                                    <Visibility className={SCA.credentialVisibilityIcon} />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                    )}
                />
            </FormControl>{' '}
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.grantType')}
                </Typography>
                <Controller
                    name="grantType"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.grantTypeInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterGrantType')}
                        />
                    )}
                />
            </FormControl>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2 }}>
                <Typography sx={{ marginRight: '48px', fontWeight: 'bold', height: '36px', alignContent: 'center' }}>
                    {t('scheduleService.scope')}
                </Typography>
                <Controller
                    name="scope"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            className={SCA.scopeInput}
                            variant="outlined"
                            size="small"
                            sx={{ width: '400px', marginLeft: 'auto' }}
                            placeholder={t('scheduleService.enterScope')}
                        />
                    )}
                />
            </FormControl>
        </Box>
    );
};
